import { Component, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import TableHead from '@/components/report-manager/TableHead/index.vue'
import TableBody from '@/components/report-manager/TableBody/index.vue'

import fetch from '@/helpers/fetch'

import vSelect from 'vue-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faFilter,
	faCaretUp,
	faChevronRight,
	faChevronLeft,
	faFileExcel,
	faCircleInfo,
} from '@fortawesome/free-solid-svg-icons'

Vue.component('v-select', vSelect)

library.add(
	faFilter,
	faCaretUp,
	faChevronRight,
	faChevronLeft,
	faFileExcel,
	faCircleInfo,
)
@Component({
	components: {
		Loader,
		TableHead,
		TableBody,
	},
})
export default class ReportManager extends Vue {
	reports: any = null
	async mounted() {
		this.request({}, 1)
	}

	options = {}

	totalCount = 0
	totalPagesArray: any[] = []
	itemsPerPage = 25
	totalPages = 0
	viewPage = 1
	numberOfTrials = 0

	downloading = false
	csvHref = ''
	downloadProp = 'gerenciar-relatorios.csv'
	async downloadCsv() {
		this.downloading = true

		const res = await fetch.post('/api/report-manager/', {})
		const csvContent = res.csv

		const encodedUri = encodeURI(csvContent)

		this.csvHref = 'data:text/csv;charset=utf-8,\uFEFF' + encodedUri

		const time = new Date().getTime() - 3 * 60 * 60 * 1000

		this.downloadProp =
			'gerenciar-relatorios-' +
			new Date(time).toISOString().substring(0, 16) +
			'.csv'

		await Vue.nextTick()
		const link: any = this.$refs.csvLink

		if (link && link.click) {
			link.click()
			this.downloading = false
		}
	}

	// async request(filters, page?) {
	// 	this.viewPage = page || 1
	// 	const resp = await this.getReportManager(
	// 		filters,
	// 		page * this.itemsPerPage - this.itemsPerPage,
	// 	)
	// 	this.reports = resp.data.groups
	// 	this.calculateNumberOfTrials(this.reports)

	// 	this.options = await this.fetchOptions()
	// 	this.totalCount = resp.totalCount

	// 	this.totalPages = Math.ceil(this.totalCount / this.itemsPerPage)
	// 	this.totalPagesArray = new Array(this.totalPages)
	// }

	// calculateNumberOfTrials(reports) {
	// 	this.numberOfTrials = 0
	// 	reports.forEach(item => {
	// 		const trials = item?.groupsRelations
	// 		trials.forEach(element => {
	// 			if (!element?.trial?.closed && !element?.trial?.mainTrial_trial_id) {
	// 				this.numberOfTrials += 1
	// 			}
	// 		})
	// 	})
	// }

	async request(filters, page?) {
		this.viewPage = page || 1
		this.reports = []
		let currentPage = this.viewPage
		let totalPages
		let lastResp

		do {
			const resp = await this.getReportManager(
				filters,
				(currentPage - 1) * this.itemsPerPage
			)

			this.reports.push(...resp.data.groups)
			lastResp = resp

			if (!totalPages) {
				totalPages = Math.ceil(resp.totalCount / this.itemsPerPage)
			}

			currentPage++
		} while (currentPage <= totalPages)

		this.calculateNumberOfTrials(this.reports)

		this.options = await this.fetchOptions()
		this.totalCount = lastResp.totalCount

		this.totalPages = totalPages
		this.totalPagesArray = new Array(this.totalPages)
	}

	calculateNumberOfTrials(reports) {
		this.numberOfTrials = 0
		reports.forEach(item => {
			const trials = item?.groupsRelations
			trials.forEach(element => {
				if (!element?.trial?.closed && !element?.trial?.mainTrial_trial_id) {
					this.numberOfTrials += 1
				}
			})
		})
	}

	async changePage(page) {
		this.viewPage = page
		this.$bvModal.hide('modal-pages')
		const tableHeadComponent: any = this.$refs.tableHeadComponent
		const filters = tableHeadComponent.getFilters()
		await this.request(filters, this.viewPage)
	}

	next() {
		if (this.viewPage < this.totalPages) {
			this.viewPage++
			this.changePage(this.viewPage)
		}
	}

	previous() {
		if (this.viewPage > 1) {
			this.viewPage--
			this.changePage(this.viewPage)
		}
	}

	async getReportManager(filters?, offset?) {
		const resp = await fetch.post('/api/report-manager/', { filters, offset })

		return resp
	}

	async fetchOptions() {
		const resp = await fetch.get('/api/report-manager/options')

		return resp.data
	}
}